module.exports = __webpack_public_path__ + "img/bg.d8b6fd9b.png";